export const getTextAssetsStyles = () => ({
  '@global': {
    '.text-asset-recommendations-panel .selectable-suggested-item-toggle': {
      height: 'auto',
      minHeight: '32px',

      '& > span': {
        margin: '8px 0',
        textAlign: 'left',
      },
    },
  },
  container: {
    '& .control-label': {
      display: 'none',
    },

    '& .text-assets-collection-container': {
      width: 'auto',
    },

    '& .text-input-container': {
      width: '100%',
    },

    '& .add-asset-btn': {
      marginBottom: '0',
    },
  },
});
